<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_1295_1947)"
    stroke="#FEFEFE"
    stroke-width="3"
  />
  <path
    d="M15.2029 46.7971L15.2029 30.0989L34.5947 10.7071L51.2929 27.4053L31.9011 46.7971L15.2029 46.7971Z"
    fill="url(#paint1_linear_1295_1947)"
    stroke="url(#paint2_linear_1295_1947)"
  />
  <path
    d="M14.7029 29.8918L34.5947 10L38.8895 14.2948L18.9978 34.1866L14.7029 47.2971L14.7029 29.8918Z"
    fill="url(#paint3_linear_1295_1947)"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20.3536 47.2975L14.7029 47.2975L14.7029 41.6467L20.3536 47.2975Z"
    fill="#010101"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1295_1947"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <linearGradient
      id="paint1_linear_1295_1947"
      x1="43.2974"
      y1="18.7027"
      x2="14.0772"
      y2="0.69177"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint2_linear_1295_1947"
      x1="51.2561"
      y1="22.2622"
      x2="31.4565"
      y2="16.734"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
    <linearGradient
      id="paint3_linear_1295_1947"
      x1="29.8977"
      y1="12.1337"
      x2="22.2163"
      y2="47.5534"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
  </defs>
</svg>
